import React from "react";
import Styles from "../../styles.module.scss";
import Button from "../../../../components/button";
import Headline5 from "../../../../components/headings/Headline5";
import { Icon } from "@iconify/react";

function AlgorithmChallenge() {
  return (
    <div className={Styles.workSurvay}>
      <Headline5>Upload a short video which will help us know you better!</Headline5>
      <p>
        Opportunities don’t happen, you create them
      </p>
      {/* <Button onClick={[]} variant="primary" size="medium">
      Upload Video Now
      </Button> */}
      <Button onClick={[]} variant="primary" size="medium">
        <Icon icon="codicon:play-circle"/>View Now
      </Button>
      <div className={Styles.time}>3 mintues</div>
    </div>
  );
}
export default AlgorithmChallenge;
